type ContentItem = {
  productId: number | string;
  qty: number;
  variantId?: number | string; // opcional
};

export function getContentIds(items: ContentItem[]): string[] {
  const contentIds: string[] = [];

  items.forEach((item) => {
    const baseId = item.variantId
      ? `variant-${item.variantId}`
      : `product-${item.productId}`;

    // repetir según qty (para Meta está ok duplicar)
    for (let i = 0; i < item.qty; i++) {
      contentIds.push(baseId);
    }
  });

  //console.log("contentIds", contentIds);
  return contentIds;
}
